import AddCommentOperation from "components/organisms/editor/core/model/lib/operation/add_comment_operation";
import Author from "components/organisms/editor/core/model/lib/author";
import AuthorList from "components/organisms/editor/core/model/lib/author_list";
import Blob from "components/organisms/editor/core/model/lib/blob";
import Change from "components/organisms/editor/core/model/lib/change";
import ChangeRequest from "components/organisms/editor/core/model/lib/change_request";
import ChangeNote from "components/organisms/editor/core/model/lib/change_note";
import Chunk from "components/organisms/editor/core/model/lib/chunk";
import ChunkResponse from "components/organisms/editor/core/model/lib/chunk_response";
import Comment from "components/organisms/editor/core/model/lib/comment";
import DeleteCommentOperation from "components/organisms/editor/core/model/lib/operation/delete_comment_operation";
import File from "components/organisms/editor/core/model/lib/file";
import FileMap from "components/organisms/editor/core/model/lib/file_map";
import History from "components/organisms/editor/core/model/lib/history";
import Label from "components/organisms/editor/core/model/lib/label";
import AddFileOperation from "components/organisms/editor/core/model/lib/operation/add_file_operation";
import MoveFileOperation from "components/organisms/editor/core/model/lib/operation/move_file_operation";
import SetCommentStateOperation from "components/organisms/editor/core/model/lib/operation/set_comment_state_operation";
import EditFileOperation from "components/organisms/editor/core/model/lib/operation/edit_file_operation";
import EditNoOperation from "components/organisms/editor/core/model/lib/operation/edit_no_operation";
import EditOperationTransformer from "components/organisms/editor/core/model/lib/operation/edit_operation_transformer";
import SetFileMetadataOperation from "components/organisms/editor/core/model/lib/operation/set_file_metadata_operation";
import NoOperation from "components/organisms/editor/core/model/lib/operation/no_operation";
import Operation from "components/organisms/editor/core/model/lib/operation";
import RestoreOrigin from "components/organisms/editor/core/model/lib/origin/restore_origin";
import RestoreFileOrigin from "components/organisms/editor/core/model/lib/origin/restore_file_origin";
import Origin from "components/organisms/editor/core/model/lib/origin";
import OtClient from "components/organisms/editor/core/model/lib/ot_client";
import TextOperation from "components/organisms/editor/core/model/lib/operation/text_operation";
import EditOperation from "components/organisms/editor/core/model/lib/operation/edit_operation";
import safePathname from "components/organisms/editor/core/model/lib/safe_pathname";
import Snapshot from "components/organisms/editor/core/model/lib/snapshot";
import util from "components/organisms/editor/core/model/lib/util";
import V2DocVersions from "components/organisms/editor/core/model/lib/v2_doc_versions";
import { InsertOp, RemoveOp, RetainOp, ScanOp } from "components/organisms/editor/core/model/lib/operation/scan_op";
import TrackedChange from "components/organisms/editor/core/model/lib/file_data/tracked_change";
import TrackedChangeList from "components/organisms/editor/core/model/lib/file_data/tracked_change_list";
import TrackingProps from "components/organisms/editor/core/model/lib/file_data/tracking_props";
import Range from "components/organisms/editor/core/model/lib/range";
import CommentList from "components/organisms/editor/core/model/lib/file_data/comment_list";
import LazyStringFileData from "components/organisms/editor/core/model/lib/file_data/lazy_string_file_data";
import StringFileData from "components/organisms/editor/core/model/lib/file_data/string_file_data";
import EditOperationBuilder from "components/organisms/editor/core/model/lib/operation/edit_operation_builder";
import { getDocUpdaterCompatibleRanges } from "components/organisms/editor/core/model/lib/doc_updater_compatible_ranges";

export {
    AddCommentOperation,
    Author,
    AuthorList,
    Blob,
    Change,
    ChangeRequest,
    ChangeNote,
    Chunk,
    ChunkResponse,
    Comment,
    DeleteCommentOperation,
    File,
    FileMap,
    LazyStringFileData,
    StringFileData,
    History,
    Label,
    AddFileOperation,
    MoveFileOperation,
    SetCommentStateOperation,
    EditFileOperation,
    EditNoOperation,
    EditOperationBuilder,
    EditOperationTransformer,
    SetFileMetadataOperation,
    NoOperation,
    Operation,
    RestoreOrigin,
    RestoreFileOrigin,
    Origin,
    OtClient,
    TextOperation,
    EditOperation,
    safePathname,
    Snapshot,
    util,
    V2DocVersions,
    ScanOp,
    InsertOp,
    RetainOp,
    RemoveOp,
    TrackedChangeList,
    TrackedChange,
    Range,
    CommentList,
    TrackingProps,
    getDocUpdaterCompatibleRanges,
};

const coreModel = {
    AddCommentOperation,
    Author,
    AuthorList,
    Blob,
    Change,
    ChangeRequest,
    ChangeNote,
    Chunk,
    ChunkResponse,
    Comment,
    DeleteCommentOperation,
    File,
    FileMap,
    LazyStringFileData,
    StringFileData,
    History,
    Label,
    AddFileOperation,
    MoveFileOperation,
    SetCommentStateOperation,
    EditFileOperation,
    EditNoOperation,
    EditOperationBuilder,
    EditOperationTransformer,
    SetFileMetadataOperation,
    NoOperation,
    Operation,
    RestoreOrigin,
    RestoreFileOrigin,
    Origin,
    OtClient,
    TextOperation,
    EditOperation,
    safePathname,
    Snapshot,
    util,
    V2DocVersions,
    ScanOp,
    InsertOp,
    RetainOp,
    RemoveOp,
    TrackedChangeList,
    TrackedChange,
    Range,
    CommentList,
    TrackingProps,
    getDocUpdaterCompatibleRanges,
};

export default coreModel;
